module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buybox-factors-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('div', {
    staticClass: "factors-grid"
  }, _vm._l((_vm.factors), function(factor, index) {
    return _c('div', {
      key: index,
      staticClass: "factor-item"
    }, [_c('div', {
      staticClass: "factor-label"
    }, [_vm._v(_vm._s(factor.name))]), _vm._v(" "), _c('div', {
      staticClass: "factor-value-row"
    }, [_c('span', {
      staticClass: "factor-value"
    }, [_vm._v(_vm._s(factor.description))]), _vm._v(" "), (factor.status === 'ok') ? _c('i', {
      staticClass: "check icon status-ok"
    }) : _c('i', {
      staticClass: "times icon status-issue"
    })])])
  }), 0), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('span', {
    staticClass: "title-icon"
  }, [_vm._v("📊")]), _vm._v("\n      Buy Box Factors\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "factor-note"
  }, [_c('span', {
    staticClass: "note-icon"
  }, [_vm._v("💡")]), _vm._v(" "), _c('span', {
    staticClass: "note-text"
  }, [_c('strong', [_vm._v("Price gap is the primary issue.")]), _vm._v(" Matching or beating $14.99 would likely recover the Buy Box since other factors are equal.\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8eedc116!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product-details/BuyBoxFactors.vue
// module id = 804
// module chunks = 2